import React from 'react';

const Card = ({ title, children, className = '', headerRight = null }) => (
  <div className={`bg-white rounded-lg shadow p-4 ${className}`}>
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
      {headerRight}
    </div>
    {children}
  </div>
);

export default Card;